// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__cHxZb","video-wrapper":"Video_video-wrapper__Ug_Jf"};